var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticker"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('marquee-component',{key:_vm.html,domProps:{"innerHTML":_vm._s(_vm.html)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }